import { Injectable } from '@angular/core';
import { DynamicForm, Fields } from 'projects/pplus/src/lib/models/components/dynamic-form.model';
import { Validators } from '@angular/forms';
import { REGEXPS } from '../../admin.model';

@Injectable({
  providedIn: 'root'
})
export class InstallationStringsDetailsService {

  private readonly generalFields: Fields[] = [
    {
      name: 'installationStringId',
      type: 'text',
      placeholder: 'ID',
      value: '',
      disabled: true,
    },
    {
      name: 'nameString',
      type: 'text',
      placeholder: 'NOMBRE',
      value: '',
      validators: [
        Validators.required,
      ],
    },
    {
      name: 'codeString',
      type: 'text',
      placeholder: 'CÓDIGO',
      value: '',
      validators: [
        Validators.required,
      ],
    },
    {
      name: 'associatedPanelType',
      type: 'text',
      placeholder: 'TIPO DE PANEL ASOCIADO',
      value: '',
      validators: [
        Validators.required,
      ],
    },
    {
      name: 'associatedNumPanel',
      type: 'text',
      placeholder: 'Nº PANELES ASOCIADOS',
      value: '',
      validators: [
        Validators.required,
        Validators.pattern(REGEXPS.numberInteger),
      ],
    },
    {
      name: 'peakPower',
      type: 'text',
      placeholder: 'POTENCIA PICO',
      value: '',
      validators: [
        Validators.pattern(REGEXPS.numberDecimal),
      ],
    },
    {
      name: 'addedText',
      type: 'text',
      placeholder: 'NOTA',
      value: '',
      validators: [
        Validators.maxLength(999),
      ],
    },
    {
      name: 'inverterId',
      type: 'select',
      label: 'INVERSOR ASOCIADO',
      value: null,
      options: [],
    },
  ];

  constructor() {}

  getDynamicForm(): DynamicForm[] {
    return [
      {
        title: 'DATOS GENERALES',
        fields: this.generalFields,
        open: true,
      },
    ];
  }

}
